<div *ngIf="isLoading$ | async">
  <div class="loading-container">
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
  </div>
</div>
